import { __rest } from "tslib";
import React from 'react';
import { EXTERNAL_ARROW_ICON } from '@marvelapp/theme';
import { Icon } from '@marvelapp/ui';
import Link from './Link';
export default function ExternalLink(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Link, Object.assign({ fontWeight: 500, kind: "marvel" }, props),
        children,
        ' ',
        React.createElement(Icon, { height: 8, paths: EXTERNAL_ARROW_ICON, viewBox: "0 0 8 8", width: 8 })));
}
